// extracted by mini-css-extract-plugin
export default {"scrollable-content":"ViewCompanyDetails_scrollable-content__GlBwS","card":"ViewCompanyDetails_card__Pd2gq","ant-card-head-title":"ViewCompanyDetails_ant-card-head-title__R3BEc"};